import React, { useEffect } from 'react'
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button, Form, Popup } from 'semantic-ui-react';
import { FormFields } from '~/components/FormFields';
import { emailRegex } from '~/components/FormFields/constants';

interface EmailFormProps {
  title: string
  emailKey: string
  requiredKey: string
}

const EmailForm: React.FC<EmailFormProps> = (props) => {
  const { control } = useFormContext();
  const { title, emailKey, requiredKey } = props
  const { t } = useTranslation()

  const required = useWatch({ control, name: requiredKey })

  const emails = useFieldArray({ control, name: emailKey })

  useEffect(() => {
    if (required === 1 && emails.fields.length === 0) {
      emails.append({ email: '' });
    }
  }, [required]);

  return (
    <>
      <Form.Field
        required={Boolean(required)}
        style={{ display: 'flex', alignItems: 'baseline' }}
      >
        <label style={{ marginRight: 10 }}>{title}</label>
        <Popup
          content={t('Add new email')}
          trigger={
            <Button
              onClick={() => emails.append({ email: '' })}
              primary
              size='mini'
              type={'button'}
              icon='plus'
            />
          }
        />
      </Form.Field>
      {emails.fields.map((type, index) => {
        return (
          <Form.Group key={type.id} style={{ alignItems: 'center' }}>
            <FormFields.Input
              control={control}
              placeholder={t('Email')}
              width={12}
              name={`${emailKey}[${index}].email`}
              rules={{
                required: {
                  value: Boolean(required),
                  message: t('Please enter email')
                },
                pattern: {
                  value: emailRegex,
                  message: t('Please enter valid email')
                }
              }}
            />
            <Form.Button
              style={{ marginLeft: 10 }}
              onClick={() => emails.remove(index)}
              size={'small'}
              basic
              color='red'
              type={'button'}
              icon='trash'
            />
          </Form.Group>
        );
      })}
    </>
  );
}
export default EmailForm